console.log("CUSTOM DESIGN JS LOADED");


const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

function preview(input, img) {

    input.addEventListener("change", function () {

        if (!this.files.length) return;

        const file = this.files[0];

        if (file.size > MAX_FILE_SIZE) {
            alert("Please upload an image smaller than 5 MB.");

            this.value = "";

            img.src = "";
            img.style.display = "none";
            return;
        }

        img.src = URL.createObjectURL(file);
        img.style.display = "block";

    });

}

preview(
    document.getElementById("frontDesign"),
    document.getElementById("frontPreview")
);

preview(
    document.getElementById("backDesign"),
    document.getElementById("backPreview")
);

preview(
    document.getElementById("logoUpload"),
    document.getElementById("logoPreview")
);






const CLOUD_NAME = "dkhcq4y8k";
const UPLOAD_PRESET = "shopify_upload";

async function uploadToCloudinary(file){

    if(!file) return "";

    const formData = new FormData();

    formData.append("file", file);

    formData.append("upload_preset", UPLOAD_PRESET);

    const response = await fetch(

        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,

        {
            method:"POST",
            body:formData
        }

    );

    const data = await response.json();

    if(data.error){

        throw new Error(data.error.message);

    }

    return data.secure_url;

}




document
.getElementById("sendDesign")
.addEventListener("click",async function(){

    this.disabled=true;

    this.innerHTML="Uploading...";

    try{

        const front=await uploadToCloudinary(

            document.getElementById("frontDesign").files[0]

        );

        const back=await uploadToCloudinary(

            document.getElementById("backDesign").files[0]

        );

        const logo=await uploadToCloudinary(

            document.getElementById("logoUpload").files[0]

        );

        const name=document.getElementById("customerName").value;

        const email=document.getElementById("customerEmail").value;

        const phone=document.getElementById("customerPhone").value;

        const note=document.getElementById("instructions").value;

        const whatsappNumber="+919909270383"; // Replace with your WhatsApp number in international format, no '+' or spaces

        const message=`

Hello,

I would like to customize a product.

Name : ${name}

Email : ${email}

Phone : ${phone}

Front Design :

${front}

Back Design :

${back}

Logo :

${logo}

Instructions :

${note}

`;

        window.open(

            `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,

            "_blank"

        );

        this.innerHTML="Done";

    }

    catch(e){

        alert(e.message);

        this.disabled=false;

        this.innerHTML="Upload & Continue";

    }

});